import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  poList: [],
  loading: false,
  error: null,
};

const poSlice = createSlice({
  name: "GetPO",
  initialState,
  reducers: {
    fetchPOStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchPOSuccess: (state, action) => {
      state.loading = false;
      state.poList = action.payload;
    },

    fetchPOFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchPOStart,
  fetchPOSuccess,
  fetchPOFailure,
} = poSlice.actions;

export default poSlice.reducer;